import script from "./EngineMenuView.vue?vue&type=script&setup=true&lang=js"
export * from "./EngineMenuView.vue?vue&type=script&setup=true&lang=js"

import "./EngineMenuView.vue?vue&type=style&index=0&id=0df25ad2&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0df25ad2"]])

export default __exports__